import { render } from "./PaletteSwatch.vue?vue&type=template&id=78766d6a"
import script from "./PaletteSwatch.vue?vue&type=script&lang=js"
export * from "./PaletteSwatch.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/PaletteSwatch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78766d6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78766d6a', __exports__)) {
    api.reload('78766d6a', __exports__)
  }
  
  module.hot.accept("./PaletteSwatch.vue?vue&type=template&id=78766d6a", () => {
    api.rerender('78766d6a', render)
  })

}


export default __exports__